import React from 'react';
import { Grid } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { IndexListItem } from 'components/styles_components/list';
import Boolean from 'components/boolean';
import useMobile from 'hooks/use_mobile';
import DeleteButton from 'components/space_users/button/delete';
import Permission from 'utils/permission';

const ListItem = ({ permission, onRemove }) => {
  const isMobile = useMobile();

  const actions = () => {
    return (
      <>
        {permission.role.toLowerCase() !== Permission().OWNER && (
          <DeleteButton permission={permission} onSuccess={onRemove} />
        )}
      </>
    );
  };

  const mobileContent = () => (
    <Grid container className="full-width" spacing={2}>
      <Grid size={{ xs: 6 }}>
        {permission.user.email}
        <br />
        {permission.user.name} {permission.user.surname}
      </Grid>
      <Grid size={{ xs: 4 }}>
        <FormattedMessage id={`user.role.${permission.role.toLowerCase()}`} />
      </Grid>
      <Grid size={{ xs: 2 }} textAlign="right">
        {actions()}
      </Grid>
    </Grid>
  );

  const desktopContent = () => (
    <Grid container className="full-width" spacing={2}>
      <Grid size={{ xs: 4 }}>{permission.user.email}</Grid>
      <Grid size={{ xs: 4 }}>
        {permission.user.name} {permission.user.surname}
      </Grid>
      <Grid size={{ xs: 2 }}>
        <FormattedMessage id={`user.role.${permission.role.toLowerCase()}`} />
      </Grid>
      <Grid size={{ xs: 1 }}>
        <Boolean value={permission.confirmed} />
      </Grid>
      <Grid size={{ xs: 1 }} textAlign="right">
        {actions()}
      </Grid>
    </Grid>
  );

  return <IndexListItem>{isMobile ? mobileContent() : desktopContent()}</IndexListItem>;
};

export default ListItem;
